module.exports = __webpack_public_path__ + "static/media/img43.b977d545.jpg";